import assetsConfig from '-/config/assets'

type StoreAssets = {
  competition: string
  postal: string
  social: string
  specialOffer: string
  singleSC: string
}

type AssetCoins = {
  sm: string
  md: string
  chest: string
}

type GiftsAssets = {
  gift1: string
  gift2: string
  gift3: string
}

type BackgroundImages = {
  smallBackground: string
}

type OutOfTokensAssets = {
  entryRequest: string
  dailyBonus: string
  socialContest: string
  freeGift: string
  buyGc: string
}

type Animations = {
  // Check Lottie component docs for more info
  loader: unknown | null
  spinningCoins: {
    gc: string
    sc: string
  }
}

export type QuestsOnboardingAssets = {
  join: string
  play: string
  claim: string
}

export type AssetConfig = {
  accountBank: string
  discussion: string
  gifts: GiftsAssets
  lock: string
  bell: string
  shield: string
  logo: {
    mobile: string
    desktop: string
  }
  store: StoreAssets
  coins: {
    gc: AssetCoins
    sc: AssetCoins
    gc_sc: AssetCoins
  }
  stacks: {
    gc: {
      md: string
    }
  }
  backgroundImages: BackgroundImages
  page404: string
  geoblock: string
  genericError: string
  outOfTokens: OutOfTokensAssets
  heroBanner: {
    firstBannerFull: string
    secondBannerFull: string
    thirdBannerFull: string
    fourthBannerFull: string
    firstBannerThumb: string
    secondBannerThumb: string
    thirdBannerThumb: string
    fourthBannerThumb: string
  }
  animations: Animations
  accessControlsConfirmationTick: string
  questsOnboardingAssets: QuestsOnboardingAssets
}

export const getBrandAssetsConfig = () => {
  return assetsConfig
}
